import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/qs-logo.png'
import _imports_1 from '@/assets/images/button-mls-import-data.png'


const _withScopeId = n => (_pushScopeId("data-v-56a23fca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "JumpStart",
  ref: "jumpStart",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block align-top" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block ps-3" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("h3", { class: "font-weight-light" }, "Welcome to QuickSource")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "To take full advantage of the power of QuickSource, enter your comps using one of the two methods below.")
  ])
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-3 p-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Import MLS Data", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Recommended for advanced users", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, "If you've already exported comps from your MLS, import them directly from your existing file.", -1))
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1 vertical-line-break" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "wordwrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "word" }, "or")
  ])
], -1))
const _hoisted_12 = { class: "col-8 p-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Manually Enter Comp Addresses"),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Recommended for new users"),
  /*#__PURE__*/_createElementVNode("div", { class: "fst-italic" }, "If you already have a list of comps but don't have an export file from your area MLS, enter the comp addresses below.")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7 text-danger" }, "* Street Address and Zip are required", -1))
const _hoisted_17 = { class: "col-5 text-end" }
const _hoisted_18 = {
  class: "mt-4 alert alert-secondary p-color-1 text-center",
  role: "alert"
}
const _hoisted_19 = ["href", "target"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-youtube" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Watch the introductory video to learn how QuickSource is going to save you time on every report.")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddManualComp = _resolveComponent("AddManualComp")!
  const _component_ModalBody = _resolveComponent("ModalBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ModalBody, null, {
            default: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "hover",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.launchMLSImportFromJumpStartModal()))
                    })
                  ])
                ]),
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_AddManualComp, { onCallback: _ctx.AddManualCompCallback }, null, 8, ["onCallback"]),
                  _createElementVNode("div", null, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: "btn btn-primary add-comps me-1",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addComp()))
                        }, "Add Comps"),
                        _createElementVNode("div", {
                          class: "btn btn-outline-secondary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exitApplication()))
                        }, "Exit QuickSource")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("a", {
                  href: _ctx.getLink(),
                  target: _ctx.getTarget()
                }, _hoisted_22, 8, _hoisted_19)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ], 512),
    (_ctx.modalConformation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConformation.component), {
          key: 0,
          message: _ctx.modalConformation.message,
          buttons: _ctx.modalConformation.buttons,
          modalSize: _ctx.modalConformation.size,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalConformation.show = false))
        }, null, 8, ["message", "buttons", "modalSize"]))
      : _createCommentVNode("", true)
  ], 64))
}